const agencyLabels = [
    {
        title: '',
        type: 'columns',
        fields: [
            {
                label: '[NOMBREEMPRESA]',
                description: 'company_name',
                visible: true
            },
            {
                label: '[NUMEROCLIENTE]',
                description: 'customer_number',
                visible: true
            },
            {
                label: '[NOMBRECLIENTE]',
                description: 'customer_name',
                visible: true
            },
            {
                label: '[APELLIDOCLIENTE]',
                description: 'customer_lastname',
                visible: true
            },
            {
                label: '[NUMEROCASILLERO]',
                description: 'Locker Number',
                visible: true
            },
            {
                label: '[USUARIOCASILLERO]',
                description: 'customer_pobox',
                visible: true
            },
            {
                label: '[DESTINATARIO]',
                description: 'Consignee',
                visible: true
            },
            {
                label: '[NOMBREAGENCIA]',
                description: 'Agency name',
                visible: true
            },
            {
                label: '[DIRECCIONAGENCIA]',
                description: 'address_agency',
                visible: true
            },
            {
                label: '[EMAILAGENCIA]',
                description: 'email_agency',
                visible: true
            },
            {
                label: '[TELEFONOAGENCIA]',
                description: 'phone_agency',
                visible: true
            },
            {
                label: '[DIRECCIONCASILLERO]',
                description: 'POBOX Address',
                visible: true
            },
            {
                label: '[DIRECCIONCASILLERO2]',
                description: 'POBOX Address 2',
                visible: true
            },
            {
                label: '[AGENTE]',
                description: 'Agent',
                visible: true
            },
            {
                label: '[LINKCASILLERO]',
                description: 'link_pobox',
                visible: true
            },
            {
                label: '[LINKTRACKING]',
                description: 'link_tracking',
                visible: true
            },
            {
                label: '[LINKEMPRESA]',
                description: 'link_company',
                visible: true
            }
        ]
    }
];

export default agencyLabels;
